import { ModalBehaviour, ModalClassNames } from 'components/modals/ModalProvider';
import { useModal } from 'components/modals/useModal';
import { useCallback } from 'react';
import { cn } from 'utils/cn';

/**
 * Pinned at the top rather than centred: an answer that shows a field, an Add that inserts a row or an error under a
 * field changes a popup's height, and a centred popup would move its top edge, and the control just pressed, with it.
 * A popup that reaches its height cap stops as far above the bottom as it starts below the top.
 */
const PINNED_PANEL = 'top-[10dvh] max-h-[80dvh] translate-y-0';

/** A press beside a popup holding half-entered answers does not throw them away. */
const KEEP_ON_OUTSIDE_PRESS: ModalBehaviour = { keepOnOutsidePress: true };

/** Opens the client identification's popups, each pinned at the top and closed only by its own buttons or Escape. */
export function useClientIdentificationPopup() {
    const { openModal, closeModal } = useModal();
    const openPopup = useCallback(
        (content: JSX.Element, size?: ModalClassNames) =>
            openModal(
                content,
                undefined,
                undefined,
                undefined,
                { ...size, panel: cn(size?.panel, PINNED_PANEL) },
                KEEP_ON_OUTSIDE_PRESS
            ),
        [openModal]
    );
    return { openPopup, closePopup: closeModal };
}
